import { render, staticRenderFns } from "./Zhuti.vue?vue&type=template&id=274ba258&scoped=true&"
import script from "./Zhuti.vue?vue&type=script&lang=js&"
export * from "./Zhuti.vue?vue&type=script&lang=js&"
import style0 from "./Zhuti.vue?vue&type=style&index=0&id=274ba258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ba258",
  null
  
)

export default component.exports